import { render, staticRenderFns } from "./DeliveryReplyList.vue?vue&type=template&id=04ecf864"
import script from "./DeliveryReplyList.vue?vue&type=script&lang=js"
export * from "./DeliveryReplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports